import { List } from "@material-ui/icons";
import RichTextInput from 'ra-input-rich-text';
import React, { useContext } from "react";
import { Button, Create, FormTab, ReferenceInput, SelectInput, TabbedForm, useRedirect } from "react-admin";
import { AppContext } from '../../providers/app-context-provider/app.context';

const ProcessNoteCreate = (props) => {

    const r = useRedirect()
    const { process, redirectTo, origin } = props.history.location.state
    const context = useContext(AppContext)
    return (
        <>
            <Button
                onClick={() => {
                    r(redirectTo, undefined, undefined, undefined, { origin })
                }}
                label={'Retornar'}
                style={{ alignSelf: 'flex-start' }}
                startIcon={<List />}
            />
            <Create {...props} onSuccess={() => {
                r(redirectTo, undefined, undefined, undefined, { origin })
            }}>
                <TabbedForm initialValues={{ process: process, author: context.currentUser.id }}>
                    <FormTab label={'Dados Gerais'} >
                        <ReferenceInput source="author" label={"Autor"} reference="users" fullWidth disabled>
                            <SelectInput source="id" optionText={"name"} />
                        </ReferenceInput>
                        <ReferenceInput source="process" label={"Atendimento"} reference="processes" fullWidth disabled>
                            <SelectInput source="id" optionText={"alias"} />
                        </ReferenceInput>
                        <RichTextInput source="text" label={'Conteúdo'} fullWidth />
                    </FormTab>
                </TabbedForm>
            </Create >
        </>
    )
}

export default ProcessNoteCreate;